var _path, _path2, _path3, _path4;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function SvgHome(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 20,
    height: 20,
    viewBox: "0 0 20 20",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M3.40039 11.8909V18.4909H8.20035V13.6909C8.20035 13.3727 8.32678 13.0674 8.55182 12.8424C8.77686 12.6174 9.08209 12.4909 9.40034 12.4909H10.6003C10.9186 12.4909 11.2238 12.6174 11.4489 12.8424C11.6739 13.0674 11.8003 13.3727 11.8003 13.6909V18.4909H16.6003V11.8909",
    stroke: "currentColor",
    strokeWidth: 2,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M1 10.6909L9.15114 2.53979C9.26258 2.42828 9.3949 2.33982 9.54054 2.27947C9.68618 2.21911 9.84228 2.18805 9.99993 2.18805C10.1576 2.18805 10.3137 2.21911 10.4593 2.27947C10.605 2.33982 10.7373 2.42828 10.8487 2.53979L18.9999 10.6909",
    stroke: "currentColor",
    strokeWidth: 2,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path3 || (_path3 = /*#__PURE__*/React.createElement("path", {
    d: "M13.5996 5.29093V4.09094H16.5996V8.29091",
    stroke: "currentColor",
    strokeWidth: 2,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path4 || (_path4 = /*#__PURE__*/React.createElement("path", {
    d: "M1.59961 18.4908H18.3995",
    stroke: "currentColor",
    strokeWidth: 2,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgHome);
export default __webpack_public_path__ + "static/media/home.caac416155f9f0535e76ed0beaa38d7a.svg";
export { ForwardRef as ReactComponent };